<template>
  <div class="content_main">
    <a-tabs default-active-key="1" @change="callback">
      <a-tab-pane key="1" tab="流动资产库存查询">
        <div style="margin-top: 10px">
          <a-button type="primary" @click="show_delivery" :disabled="selectedRowKeysTabItems.length < 1">出库</a-button>
          <a-button type="primary" @click="show_apply" :disabled="selectedRowKeysTabItems.length < 1">申领</a-button>
          <a-button type="primary" @click="exp"> 导出 </a-button>
        </div>
        <div class="content_main_top">
          <!-- <a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" /> -->
          <a-input v-model="name" allowClear class="a_input_self margin_self" placeholder="物品名称" />
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            allowClear
            @change="onChange2"
            :placeholder="['采购开始', '采购结束']"
          />
          <a-button type="primary" @click="query" style="margin-left: 10px"> 查询 </a-button>
        </div>
        <div class="content_main_center" id="content_main_center" style="height: calc(100% - 142px)">
          <a-table
            :columns="columns"
            :data-source="data"
            rowKey="id"
            :row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChangeTab }"
            bordered
            :pagination="false"
            :scroll="{ y: scroll_y }"
          >
            <span slot="dept_id" slot-scope="text">
              {{ text ? deptMap[text].text : '' }}
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="details(record)">详情</a>
            </span>
          </a-table>
        </div>
        <div class="content_main_bot">
          <a-pagination
            v-model="current"
            show-size-changer
            :page-size.sync="pageSize"
            :total="total"
            @showSizeChange="showSizeChange"
            :pageSizeOptions="['10', '20', '30', '50']"
            @change="onShowSizeChange"
          />
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="固定资产库存查询">
        <div class="content_main_top">
          <!-- <a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" /> -->
          <a-input v-model="name2" allowClear class="a_input_self margin_self" placeholder="请输入物品名称" />
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            allowClear
            @change="onChange"
            :placeholder="['采购开始日期', '采购结束日期']"
          />
          <a-button type="primary" @click="query2" style="margin-left: 10px"> 查询 </a-button>
          <a-button type="primary" @click="exp2"> 导出 </a-button>
        </div>
        <div class="content_main_center" id="content_main_center">
          <a-table
            :columns="columns2"
            :data-source="data2"
            bordered
            :pagination="false"
            :scroll="{ x: 1200, y: scroll_y }"
          >
            <span slot="asset_type" slot-scope="text">
              {{ text ? operTypeMap[text].text : '' }}
            </span>
            <span slot="state" slot-scope="text">
              {{ text ? statusMap[text] : '' }}
            </span>
            <span slot="dept_id" slot-scope="text">
              {{ text ? deptMap[text].text : '' }}
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="details(record)">详情</a>
            </span>
          </a-table>
        </div>
        <div class="content_main_bot">
          <a-pagination
            v-model="current2"
            show-size-changer
            :page-size.sync="pageSize2"
            :total="total2"
            @showSizeChange="showSizeChange2"
            :pageSizeOptions="['10', '20', '30', '50']"
            @change="onShowSizeChange2"
          />
        </div>
      </a-tab-pane>
      <a-tab-pane key="3" tab="耗材入库">
        <div class="content_main_top">
          <!-- <a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" /> -->
          <!-- <a-input v-model="company3" allowClear class="a_input_self margin_self" placeholder="请输入公司名称" /> -->
          <a-input v-model="name3" allowClear class="a_input_self margin_self" placeholder="请输入物品名称" />
          <a-input v-model="model3" allowClear class="a_input_self margin_self" placeholder="请输入规格型号" />
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            allowClear
            @change="onChange3"
            :placeholder="['入库开始日期', '入库结束日期']"
          />
          <a-button type="primary" @click="query3" style="margin-left: 10px"> 查询 </a-button>
          <a-button type="primary" @click="exp3"> 导出 </a-button>
        </div>
        <div class="content_main_center" id="content_main_center">
          <a-table
            :columns="columns3"
            :data-source="data3"
            bordered
            :pagination="false"
            :scroll="{ x: 1200, y: scroll_y }"
          >
            <span slot="dept_id" slot-scope="text">
              {{ text ? deptMap[text].text : '' }}
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="details(record)">详情</a>
            </span>
          </a-table>
        </div>
        <div class="content_main_bot">
          <a-pagination
            v-model="current3"
            show-size-changer
            :page-size.sync="pageSize3"
            :total="total3"
            @showSizeChange="showSizeChange3"
            :pageSizeOptions="['10', '20', '30', '50']"
            @change="onShowSizeChange3"
          />
        </div>
      </a-tab-pane>
      <a-tab-pane key="4" tab="资产入库">
        <div class="content_main_top">
          <!-- <a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" /> -->
          <!-- <a-input v-model="company4" allowClear class="a_input_self margin_self" placeholder="请输入公司名称" /> -->
          <a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" />
          <a-input v-model="name4" allowClear class="a_input_self margin_self" placeholder="请输入物品名称" />
          <a-input v-model="model4" allowClear class="a_input_self margin_self" placeholder="请输入规格型号" />
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            allowClear
            @change="onChange4"
            :placeholder="['入库开始日期', '入库结束日期']"
          />
          <a-button type="primary" @click="query4" style="margin-left: 10px"> 查询 </a-button>
          <a-button type="primary" @click="exp4"> 导出 </a-button>
        </div>
        <div class="content_main_center" id="content_main_center">
          <a-table
            :columns="columns5"
            :data-source="data4"
            bordered
            :pagination="false"
            :scroll="{ x: 1200, y: scroll_y }"
          >
            <span slot="state" slot-scope="text">
              {{ text ? statusMap[text] : '' }}
            </span>
            <span slot="dept_id" slot-scope="text">
              {{ text ? deptMap[text].text : '' }}
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="details(record)">详情</a>
            </span>
          </a-table>
        </div>
        <div class="content_main_bot">
          <a-pagination
            v-model="current4"
            show-size-changer
            :page-size.sync="pageSize4"
            :total="total4"
            @showSizeChange="showSizeChange4"
            :pageSizeOptions="['10', '20', '30', '50']"
            @change="onShowSizeChange4"
          />
        </div>
      </a-tab-pane>
      <a-tab-pane key="5" tab="耗材出库">
        <div class="content_main_top">
          <!-- <a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" /> -->
          <!-- <a-input v-model="company5" allowClear class="a_input_self margin_self" placeholder="请输入公司名称" /> -->
          <a-input v-model="name5" allowClear class="a_input_self margin_self" placeholder="请输入物品名称" />
          <a-input v-model="model5" allowClear class="a_input_self margin_self" placeholder="请输入规格型号" />
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            allowClear
            @change="onChange5"
            :placeholder="['出库开始日期', '出库结束日期']"
          />
          <a-button type="primary" @click="query5" style="margin-left: 10px"> 查询 </a-button>
          <a-button type="primary" @click="exp5"> 导出 </a-button>
        </div>
        <div class="content_main_center" id="content_main_center">
          <a-table
            :columns="columns4"
            :data-source="data5"
            bordered
            :pagination="false"
            :scroll="{ x: 1200, y: scroll_y }"
          >
            <span slot="state" slot-scope="text">
              {{ text ? statusMap[text] : '' }}
            </span>
            <span slot="dept_id" slot-scope="text">
              {{ text ? deptMap[text].text : '' }}
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="details(record)">详情</a>
            </span>
          </a-table>
        </div>
        <div class="content_main_bot">
          <a-pagination
            v-model="current5"
            show-size-changer
            :page-size.sync="pageSize5"
            :total="total5"
            @showSizeChange="showSizeChange5"
            :pageSizeOptions="['10', '20', '30', '50']"
            @change="onShowSizeChange5"
          />
        </div>
      </a-tab-pane>
      <a-tab-pane key="6" tab="资产出库">
        <div class="content_main_top">
          <!-- <a-input v-model="asset_sn" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" /> -->
          <!-- <a-input v-model="company6" allowClear class="a_input_self margin_self" placeholder="请输入公司名称" /> -->
          <a-input v-model="asset_sn2" allowClear class="a_input_self margin_self" placeholder="请输入物品编码" />
          <a-input v-model="name6" allowClear class="a_input_self margin_self" placeholder="请输入物品名称" />
          <a-input v-model="model6" allowClear class="a_input_self margin_self" placeholder="请输入规格型号" />
          <a-range-picker
            valueFormat="YYYY-MM-DD"
            allowClear
            @change="onChange6"
            :placeholder="['出库开始日期', '出库结束日期']"
          />
          <a-button type="primary" @click="query6" style="margin-left: 10px"> 查询 </a-button>
          <a-button type="primary" @click="exp6"> 导出 </a-button>
        </div>
        <div class="content_main_center" id="content_main_center">
          <a-table
            :columns="columns6"
            :data-source="data6"
            bordered
            :pagination="false"
            :scroll="{ x: 1200, y: scroll_y }"
          >
            <span slot="state" slot-scope="text">
              {{ text ? statusMap[text] : '' }}
            </span>
            <span slot="dept_id" slot-scope="text">
              {{ text ? deptMap[text].text : '' }}
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="details(record)">详情</a>
            </span>
          </a-table>
        </div>
        <div class="content_main_bot">
          <a-pagination
            v-model="current6"
            show-size-changer
            :page-size.sync="pageSize6"
            :total="total6"
            @showSizeChange="showSizeChange6"
            :pageSizeOptions="['10', '20', '30', '50']"
            @change="onShowSizeChange6"
          />
        </div>
      </a-tab-pane>
      <a-modal title="详情" :visible="detailsvisible" @cancel="detailsCancel" width="880px">
        <template slot="footer">
          <a-button type="primary" @click="detailsOk"> 确定 </a-button>
        </template>
        <a-form-model :model="detailsrow" style="height: 500px">
          <a-form-model-item label="资产类别" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.asset_type ? operTypeMap[detailsrow.asset_type].text : '' }}</span>
          </a-form-model-item>
          <a-form-model-item label="物品状态" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.state ? statusMap[detailsrow.state] : '' }}</span>
          </a-form-model-item>
          <a-form-model-item label="物品名称" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.name }}</span>
          </a-form-model-item>
          <a-form-model-item label="采购时间" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.purchase_time }}</span>
          </a-form-model-item>
          <a-form-model-item label="是否仪器" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.is_instrument == null ? '' : instrumentMap[detailsrow.is_instrument] }}</span>
          </a-form-model-item>
          <a-form-model-item label="采购价格" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.purchase_price }}</span>
          </a-form-model-item>
          <a-form-model-item label="物品编号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.asset_sn }}</span>
          </a-form-model-item>
          <a-form-model-item label="供应商" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.dealer }}</span>
          </a-form-model-item>
          <a-form-model-item label="规格型号" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.model }}</span>
          </a-form-model-item>
          <a-form-model-item label="负责部门" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.dept_id ? deptMap[detailsrow.dept_id].text : '' }}</span>
          </a-form-model-item>
          <a-form-model-item label="责任人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.charger }}</span>
          </a-form-model-item>
          <a-form-model-item label="物品数量" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.amount }}</span>
          </a-form-model-item>
          <a-form-model-item label="入库人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.operator }}</span>
          </a-form-model-item>
          <a-form-model-item label="准用说明" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.permit }}</span>
          </a-form-model-item>
          <a-form-model-item label="保管人" :labelCol="labelCol" :wrapperCol="wrapperCol" class="form_item">
            <span>{{ detailsrow.keeper }}</span>
          </a-form-model-item>
          <a-form-model-item
            label="最后检定时间"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            class="form_item"
            v-if="detailsrow.is_instrument"
          >
            <span>{{ detailsrow.inspect_time }}</span>
          </a-form-model-item>
          <a-form-model-item
            label="检定结果"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            class="form_item"
            v-if="detailsrow.is_instrument"
          >
            <span>{{ detailsrow.inspect_result }}</span>
          </a-form-model-item>
          <a-form-model-item
            label="精度"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            class="form_item"
            v-if="detailsrow.is_instrument"
          >
            <span>{{ detailsrow.precisions }}</span>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <!-- 出库 -->
      <a-modal v-model="is_delivery" title="直接出库" width="60%">
        <template slot="footer">
          <a-button key="back" @click="is_delivery = false"> 取消 </a-button>
          <a-button key="submit" type="primary" @click="handleOk_delivery"> 出库 </a-button>
        </template>
        <a-table :data-source="selectedRowKeysTabItems" bordered :pagination="false">
          <a-table-column key="name" title="物品名称" data-index="name" />
          <a-table-column key="operator" title="入库人" data-index="operator" />
          <a-table-column key="keeper" title="保管人" data-index="keeper" />
          <a-table-column key="purchase_price" title="采购价格" data-index="purchase_price" />
          <a-table-column key="value" title="当前估值" data-index="value" />
          <a-table-column key="amount" title="物品数量" data-index="amount" />
          <a-table-column key="delivery_amount" title="出库数量" data-index="delivery_amount" width="200px">
            <template scope="text,record">
              <a-input type="number" :max="record.delivery_amount" min="1" v-model="record.delivery_amount" />
            </template>
          </a-table-column>
        </a-table>
      </a-modal>
      <a-modal v-model="is_apply_show" title="领用申请" width="60%">
        <template slot="footer">
          <a-button key="back" @click="is_apply_show = false"> 取消 </a-button>
          <a-button key="submit" type="primary" @click="apply_delivery"> 领用出库 </a-button>
        </template>
        <a-form-model
          :rules="apply_rules"
          ref="apply_ref"
          :model="apply_info"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="申领标题" prop="title">
                <a-input v-model="apply_info.title" placeholder="请输入" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="选择部门">
                <a-cascader :options="options" placeholder="请选择" @change="onChangeDept" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="选择抄送人" prop="ccs">
                <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
                  全选
                </a-checkbox>
                <a-checkbox-group
                  v-model="apply_info.ccs"
                  name="ccs"
                  :options="checkAllOptions"
                  @change="onChangeFroup"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="申领原因" prop="reason">
                <a-textarea v-model="apply_info.reason" placeholder="请输入" :auto-size="{ minRows: 1, maxRows: 3 }" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-model-item label="备注">
                <a-textarea v-model="apply_info.remark" placeholder="请输入" :auto-size="{ minRows: 1, maxRows: 3 }" />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-table :data-source="apply_info.old_goods" bordered :pagination="false">
              <a-table-column key="name" title="物品名称" data-index="name" />
              <a-table-column key="operator" title="入库人" data-index="operator" />
              <a-table-column key="keeper" title="保管人" data-index="keeper" />
              <a-table-column key="purchase_price" title="采购价格" data-index="purchase_price" />
              <a-table-column key="value" title="当前估值" data-index="value" />
              <a-table-column key="amount" title="物品数量" data-index="amount" />
              <a-table-column key="delivery_amount" title="申领数量" data-index="delivery_amount" width="200px">
                <template scope="text,record">
                  <a-input
                    type="number"
                    :max="record.delivery_amount"
                    @blur="set_max_min(record)"
                    v-model="record.delivery_amount"
                  />
                </template>
              </a-table-column>
            </a-table>
          </a-row>
        </a-form-model>
      </a-modal>
    </a-tabs>
  </div>
</template>

<script>
import {
  skuget_list,
  assetget_list2,
  dict,
  sku_checkin,
  asset_checkin,
  sku_checkout,
  claim_apply,
  asset_checkout,
} from '@/api/assetmenag'
import { getDeptListEnable } from '@/api/system'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { returnDept, get_users, get_dict } from '@/utils/unit_axios'
const columns = [
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '入库人',
    dataIndex: 'operator',
    key: 'operator',
  },
  {
    title: '保管人',
    dataIndex: 'keeper',
    key: 'keeper',
  },
  {
    title: '物品数量',
    dataIndex: 'amount',
    key: 'amount',
  },
  {
    title: '采购时间',
    dataIndex: 'purchase_time',
    key: 'purchase_time',
  },
  {
    title: '采购价格',
    dataIndex: 'price',
    key: 'price',
    scopedSlots: {
      customRender: 'price',
    },
  },
  {
    title: '当前估值',
    dataIndex: 'value',
    key: 'value',
    scopedSlots: {
      customRender: 'value',
    },
  },
  {
    title: '供应商',
    dataIndex: 'dealer',
    key: 'dealer',
  },
  {
    title: '责任人',
    dataIndex: 'charger',
    key: 'charger',
  },
  {
    title: '责任部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
  },
]
const columns2 = [
  {
    title: '资产类别',
    dataIndex: 'asset_type',
    key: 'asset_type',
    scopedSlots: {
      customRender: 'asset_type',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品编号',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
    width: 150,
    ellipsis: true,
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
    width: 300,
    ellipsis: true,
  },
  {
    title: '物品数量',
    dataIndex: 'amount',
    key: 'amount',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: {
      customRender: 'state',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '准用说明',
    dataIndex: 'permit',
    key: 'permit',
    width: 150,
    ellipsis: true,
  },
  {
    title: '采购时间',
    dataIndex: 'purchase_time',
    key: 'purchase_time',
    width: 150,
    ellipsis: true,
  },
  {
    title: '采购价格',
    dataIndex: 'purchase_price',
    key: 'purchase_price',
    width: 150,
    ellipsis: true,
  },
  {
    title: '当前估值',
    dataIndex: 'value',
    key: 'value',
    width: 150,
    ellipsis: true,
  },
  {
    title: '供应商',
    dataIndex: 'dealer',
    key: 'dealer',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任人',
    dataIndex: 'charger',
    key: 'charger',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    width: 150,
  },
]
const columns3 = [
  {
    title: '公司名称',
    dataIndex: 'company_name',
    key: 'company_name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
    width: 300,
    ellipsis: true,
  },
  {
    title: '入库人员',
    dataIndex: 'operator',
    key: 'operator',
    width: 150,
    ellipsis: true,
  },
  {
    title: '入库时间',
    dataIndex: 'time',
    key: 'time',
    width: 150,
    ellipsis: true,
  },
  {
    title: '准用说明',
    dataIndex: 'permit',
    key: 'permit',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品数量',
    dataIndex: 'amount',
    key: 'amount',
    width: 150,
    ellipsis: true,
  },
  {
    title: '当前估值',
    dataIndex: 'value',
    key: 'value',
    width: 150,
    ellipsis: true,
  },
  {
    title: '保管人',
    dataIndex: 'keeper',
    key: 'keeper',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    width: 150,
  },
]
const columns4 = [
  {
    title: '公司名称',
    dataIndex: 'company_name',
    key: 'company_name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
    width: 300,
    ellipsis: true,
  },
  {
    title: '物品状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: {
      customRender: 'state',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '出库人员',
    dataIndex: 'operator',
    key: 'operator',
    width: 150,
    ellipsis: true,
  },
  {
    title: '出库时间',
    dataIndex: 'time',
    key: 'time',
    width: 150,
    ellipsis: true,
  },
  {
    title: '准用说明',
    dataIndex: 'permit',
    key: 'permit',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品数量',
    dataIndex: 'amount',
    key: 'amount',
    width: 150,
    ellipsis: true,
  },
  {
    title: '当前估值',
    dataIndex: 'value',
    key: 'value',
    width: 150,
    ellipsis: true,
  },
  {
    title: '保管人',
    dataIndex: 'dealer',
    key: 'dealer',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任人',
    dataIndex: 'charger',
    key: 'charger',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    width: 150,
  },
]
const columns5 = [
  {
    title: '公司名称',
    dataIndex: 'company_name',
    key: 'company_name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品编码',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
    width: 150,
    ellipsis: true,
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
    width: 300,
    ellipsis: true,
  },
  {
    title: '物品状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: {
      customRender: 'state',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '入库人员',
    dataIndex: 'operator',
    key: 'operator',
    width: 150,
    ellipsis: true,
  },
  {
    title: '入库时间',
    dataIndex: 'time',
    key: 'time',
    width: 150,
    ellipsis: true,
  },
  {
    title: '准用说明',
    dataIndex: 'permit',
    key: 'permit',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品数量',
    dataIndex: 'amount',
    key: 'amount',
    width: 150,
    ellipsis: true,
  },
  {
    title: '当前估值',
    dataIndex: 'value',
    key: 'value',
    width: 150,
    ellipsis: true,
  },
  {
    title: '保管人',
    dataIndex: 'dealer',
    key: 'dealer',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任人',
    dataIndex: 'charger',
    key: 'charger',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    width: 150,
  },
]
const columns6 = [
  {
    title: '公司名称',
    dataIndex: 'company_name',
    key: 'company_name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品名称',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品编码',
    dataIndex: 'asset_sn',
    key: 'asset_sn',
    width: 150,
    ellipsis: true,
  },
  {
    title: '规格型号',
    dataIndex: 'model',
    key: 'model',
    width: 300,
    ellipsis: true,
  },
  {
    title: '物品状态',
    dataIndex: 'state',
    key: 'state',
    scopedSlots: {
      customRender: 'state',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '出库人员',
    dataIndex: 'operator',
    key: 'operator',
    width: 150,
    ellipsis: true,
  },
  {
    title: '出库时间',
    dataIndex: 'time',
    key: 'time',
    width: 150,
    ellipsis: true,
  },
  {
    title: '准用说明',
    dataIndex: 'permit',
    key: 'permit',
    width: 150,
    ellipsis: true,
  },
  {
    title: '物品数量',
    dataIndex: 'amount',
    key: 'amount',
    width: 150,
    ellipsis: true,
  },
  {
    title: '当前估值',
    dataIndex: 'value',
    key: 'value',
    width: 150,
    ellipsis: true,
  },
  {
    title: '保管人',
    dataIndex: 'dealer',
    key: 'dealer',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任人',
    dataIndex: 'charger',
    key: 'charger',
    width: 150,
    ellipsis: true,
  },
  {
    title: '责任部门',
    dataIndex: 'dept_id',
    key: 'dept_id',
    scopedSlots: {
      customRender: 'dept_id',
    },
    width: 150,
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: {
      customRender: 'action',
    },
    width: 150,
  },
]

const deptMap = {}
export default {
  data() {
    return {
      statusMap: '',
      is_delivery: false,
      selectedRowKeysTab: [],
      selectedRowKeysTabItems: [],
      is_apply_show: false,
      apply_info: {
        title: '',
        ccs: [],
        cs: '',
        deptKey: '',
        reason: '', //
        remark: '',
        old_goods: [],
        goods: [],
      },
      apply_rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        reason: [{ required: true, message: '请输入申领原因', trigger: 'blur' }],
        ccs: [
          {
            type: 'array',
            required: true,
            message: '请选择抄送人',
            trigger: 'change',
          },
        ],
      },
      options: [], //部门
      checkAll: false,
      indeterminate: false,
      checkAllOptions: [], //全项
      scroll_y: 150,
      selectedRowKeys: [],
      deptMap,
      operTypeMap: {},
      changevisible: false,
      data: [],
      data2: [],
      data3: [],
      data4: [],
      data5: [],
      deptTree: [],
      assettype: [],
      columns,
      columns2,
      columns3,
      columns4,
      columns5,
      visible: false,
      visibleClaim: false,
      visibleexamine: false,
      editvisible: false,
      loading: false,
      Warehousingvisible: false,
      selectedRowKeys: [],
      selectedRow: [],
      name: '',
      start_date: '',
      end_date: '',
      pageSize: 10,
      current: 1,
      total: 0,
      pageSize2: 10,
      current2: 1,
      total2: 0,
      pageSize3: 10,
      current3: 1,
      total3: 0,
      pageSize4: 10,
      current4: 1,
      total4: 0,
      pageSize5: 10,
      current5: 1,
      total5: 0,
      pageSize6: 10,
      current6: 1,
      total6: 0,
      name2: '',
      start_date2: '',
      end_date2: '',
      name3: '',
      model3: '',
      company3: '',
      start_date3: '',
      end_date3: '',
      name4: '',
      asset_sn: '',
      asset_sn2: '',
      model4: '',
      company4: '',
      start_date4: '',
      end_date4: '',
      name5: '',
      model5: '',
      company5: '',
      start_date5: '',
      end_date5: '',
      name6: '',
      model6: '',
      company6: '',
      start_date6: '',
      end_date6: '',
      detailsrow: {},
      Warehousingrow: {},
      detailsvisible: false,
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    }
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
  },
  filters: {
    operTypeFilter(type) {
      return operTypeMap[type].text
    },
    deptFilter(type) {
      return deptMap[type].text
    },
  },
  created() {
    get_dict('goodStatus', (res) => {
      console.log(res)
      this.statusMap = res
    })
    dict({
      pageNum: 1,
      pageSize: 10,
      dictType: 'assets_type',
    }).then((res) => {
      this.assettype = res.rows
      this.assettype.map((d) => {
        this.operTypeMap[d.dictCode] = {
          text: d.dictLabel,
        }
      })
    })
    getDeptListEnable().then((res) => {
      const data = res.rows
      if (data.length > 0) {
        const min = Math.min(...data.map((m) => m.parentId))
        this.buildtree2(data, this.deptTree, min)
        this.deptTree.map((d) => {
          if (d.hasOwnProperty('children')) {
            d.children.map((b) => {
              deptMap[b.key] = {
                text: b.title,
              }
              deptMap[d.key] = {
                text: d.title,
              }
            })
          } else {
            deptMap[d.key] = {
              text: d.title,
            }
          }
        })
        this.expandedKeys = data.map((m) => m.parentId)
        this.dataList = data.map((m) => {
          return {
            key: m.deptId,
            title: m.deptName,
          }
        })
      }
    })
    this.get_sku()
    this.get_lis()
    this.get_checkin()
    this.get_checkin2()
    this.get_checkin3()
    this.get_checkin4()
  },
  mounted() {
    returnDept((res) => {
      this.options = res.depts
    })
    this.$nextTick(() => {
      var max_h = $('#content_main_center').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height()
      }, 1000)
    })
  },
  methods: {
    //选择第一个表格
    onSelectChangeTab(selectedRowKeys, selectedRows) {
      this.selectedRowKeysTabItems = JSON.parse(JSON.stringify(selectedRows))
      this.selectedRowKeysTab = selectedRowKeys
    },
    //显示出库
    show_delivery() {
      this.selectedRowKeysTabItems.forEach((item) => {
        item['delivery_amount'] = 1
      })
      this.is_delivery = true
    },
    //点击出库
    handleOk_delivery() {
      console.log(this.selectedRowKeysTabItems)
    },
    //弹出领用出库
    show_apply() {
      this.apply_info = {
        title: '',
        ccs: [],
        cs: '',
        deptKey: '',
        reason: '', //
        remark: '',
        old_goods: [],
        goods: [],
      }
      this.selectedRowKeysTabItems.forEach((item) => {
        item['delivery_amount'] = 1
      })
      this.apply_info.old_goods = this.selectedRowKeysTabItems
      this.is_apply_show = true
    },
    //选择部门
    onChangeDept(value) {
      this.apply_info.ccs = []
      this.checkAll = false
      this.apply_info.deptKey = value[1]
      get_users(value[1], (res) => {
        res.forEach((item) => {
          item['label'] = item.userName
          item['value'] = item.userId
        })
        this.checkAllOptions = res
      })
    },
    //全选改变
    onCheckAllChange(e) {
      var vs = []
      this.checkAllOptions.forEach((item) => {
        vs.push(item.value)
      })
      this.apply_info.ccs = e.target.checked ? vs : []
      this.indeterminate = false
      this.checkAll = e.target.checked
    },
    // 某项改变
    onChangeFroup(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.checkAllOptions.length
      this.checkAll = checkedList.length === this.checkAllOptions.length
    },
    //限制最大值
    set_max_min(row) {
      let max = row.amount
      if (row.delivery_amount < 1) {
        row.delivery_amount = 1
      }
      if (row.delivery_amount > max) {
        row.delivery_amount = max
      }
      this.$forceUpdate()
    },
    //点击领用出库
    apply_delivery() {
      this.$refs.apply_ref.validate((valid) => {
        if (valid) {
          this.apply_info.old_goods.forEach((item) => {
            this.apply_info.goods.push({
              goodsId: item.id,
              claimNum: item.delivery_amount * 100,
            })
          })
          this.apply_info.cc = this.apply_info.ccs.join(',')
          claim_apply(this.apply_info).then((res) => {
            if (res.code != 200) {
              this.$message.error(res.msg)
              return
            }
            this.$message.success('申领成功')
            this.get_sku()
            this.is_apply_show = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    get_checkin4() {
      asset_checkout({
        page_size: this.pageSize6,
        page_num: this.current6,
        model: this.model6,
        asset_sn: this.asset_sn2,
        name: this.name6,
        start_date: this.start_date6,
        end_date: this.end_date6,
      }).then((res) => {
        this.total6 = res.data.total
        this.data6 = res.data.items
        // this.data6.forEach((item) => {
        //   item.purchase_price = item.purchase_price / 100
        //   item.value = item.value / 100
        //   item.amount = item.amount / 100
        // })
      })
    },
    get_checkin3() {
      sku_checkout({
        page_size: this.pageSize5,
        page_num: this.current5,
        model: this.model5,
        name: this.name5,
        start_date: this.start_date5,
        end_date: this.end_date5,
      }).then((res) => {
        this.total5 = res.data.total
        this.data5 = res.data.items
        // this.data5.forEach((item) => {
        //   item.purchase_price = item.purchase_price / 100
        //   item.value = item.value / 100
        //   item.amount = item.amount / 100
        // })
      })
    },
    get_checkin2() {
      asset_checkin({
        page_size: this.pageSize4,
        page_num: this.current4,
        model: this.model4,
        asset_sn: this.asset_sn,
        name: this.name4,
        start_date: this.start_date4,
        end_date: this.end_date4,
      }).then((res) => {
        this.total4 = res.data.total
        this.data4 = res.data.items
        // this.data4.forEach((item) => {
        //   item.purchase_price = item.purchase_price / 100
        //   item.value = item.value / 100
        //   item.amount = item.amount / 100
        // })
      })
    },
    get_checkin() {
      sku_checkin({
        page_size: this.pageSize3,
        page_num: this.current3,
        model: this.model3,
        name: this.name3,
        start_date: this.start_date3,
        end_date: this.end_date3,
      }).then((res) => {
        this.total3 = res.data.total
        this.data3 = res.data.items
        // this.data3.forEach((item) => {
        //   item.purchase_price = item.purchase_price / 100
        //   item.value = item.value / 100
        //   item.amount = item.amount / 100
        // })
      })
    },
    detailsOk() {
      this.detailsvisible = false
    },
    detailsCancel() {
      this.detailsvisible = false
    },
    details(row) {
      this.detailsvisible = true
      this.detailsrow = row
    },
    onChange(date, dateString) {
      this.start_date = date[0]
      this.end_date = date[1]
    },
    onChange2(date, dateString) {
      this.start_date2 = date[0]
      this.end_date2 = date[1]
    },
    onChange3(date, dateString) {
      this.start_date3 = date[0]
      this.end_date3 = date[1]
    },
    onChange4(date, dateString) {
      this.start_date4 = date[0]
      this.end_date4 = date[1]
    },
    onChange5(date, dateString) {
      this.start_date5 = date[0]
      this.end_date5 = date[1]
    },
    onChange6(date, dateString) {
      this.start_date6 = date[0]
      this.end_date6 = date[1]
    },
    get_lis() {
      assetget_list2({
        page_size: this.pageSize2,
        page_num: this.current2,
        name: this.name2,
        start_date: this.start_date,
        end_date: this.end_date,
      }).then((res) => {
        this.total2 = res.data.total
        this.data2 = res.data.items
        // this.data2.forEach((item) => {
        //   item.purchase_price = item.purchase_price / 100
        //   item.value = item.value / 100
        //   item.amount = item.amount / 100
        // })
      })
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    get_sku() {
      skuget_list({
        page_size: this.pageSize,
        page_num: this.current,
        name: this.name,
        start_date: this.start_date2,
        end_date: this.end_date2,
      }).then((res) => {
        this.total = res.data.total
        this.data = res.data.items
        // this.data.forEach((item) => {
        //   item.price = item.price / 100
        //   item.value = item.value / 100
        //   item.amount = item.amount / 100
        // })
      })
    },
    showSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.get_sku()
    },
    onShowSizeChange(current, pageSize) {
      this.current = current
      this.get_sku()
    },
    showSizeChange2(current, pageSize) {
      this.pageSize2 = pageSize
      this.current2 = current
      this.get_lis()
    },
    onShowSizeChange2(current, pageSize) {
      this.current2 = current
      this.get_lis()
    },
    showSizeChange3(current, pageSize) {
      this.pageSize3 = pageSize
      this.current3 = current
      this.get_checkin()
    },
    onShowSizeChange3(current, pageSize) {
      this.current3 = current
      this.get_checkin()
    },
    showSizeChange4(current, pageSize) {
      this.pageSize4 = pageSize
      this.current4 = current
      this.get_checkin2()
    },
    onShowSizeChange4(current, pageSize) {
      this.current4 = current
      this.get_checkin2()
    },
    showSizeChange5(current, pageSize) {
      this.pageSize5 = pageSize
      this.current5 = current
      this.get_checkin3()
    },
    onShowSizeChange5(current, pageSize) {
      this.current5 = current
      this.get_checkin3()
    },
    showSizeChange6(current, pageSize) {
      this.pageSize6 = pageSize
      this.current6 = current
      this.get_checkin4()
    },
    onShowSizeChange6(current, pageSize) {
      this.current6 = current
      this.get_checkin4()
    },
    query() {
      this.get_sku()
    },
    exp() {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/sku/get_list?name='+this.name+'&start_date='+this.start_date2+'&end_date='+this.end_date2+'&excel=1'
      a.download = 'test'
      a.click()
    },
    query2() {
      this.get_lis()
    },
    query3() {
      this.get_checkin()
    },
    query4() {
      this.get_checkin2()
    },
    query5() {
      this.get_checkin3()
    },
    query6() {
      this.get_checkin4()
    },
    exp2() {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_list2?excel=1'
      a.download = 'test'
      a.click()
    },
    exp3() {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/sku/get_checkin_records?excel=1'
      a.download = 'test'
      a.click()
    },
    exp4() {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_checkin_records?excel=1'
      a.download = 'test'
      a.click()
    },
    exp5() {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/sku/get_checkout_records?excel=1'
      a.download = 'test'
      a.click()
    },
    exp6() {
      const tok = storage.get(ACCESS_TOKEN)
      this.headers = {
        token: tok,
      }
      let a = document.createElement('a')
      a.href = 'https://coa.anliantest.com/oaProxyApi/proxyPython/asset/get_checkout_records?excel=1'
      a.download = 'test'
      a.click()
    },
  },
}
</script>

<style>
.form_item {
  float: left;
  width: 50%;
  height: 50px;
  margin-bottom: 10px;
}
</style>
